const form = {
    formId: "new-employee-form",
    formField: {
        avatar: {
            name: "avatar",
            label: "Avatar",
            errorMsg: "Vui lòng chọn ảnh",
        },
        name: {
            name: "name",
            label: "Họ tên nhân viên",
            type: "text",
            placeholder: "",
            errorMsg: "Vui lòng nhập họ tên",
        },
        company: {
            name: "company",
            label: "Công ty",
            type: "text",
            placeholder: "Chọn",
            errorMsg: "Vui lòng chọn công ty",
        },

        email: {
            name: "email",
            label: "Email",
            type: "email",
            placeholder: "",
            errorMsg: "Vui lòng nhập email",
            invalidMsg: "Email không hợp lệ",
        },
        phone: {
            name: "phone",
            label: "Số điện thoại",
            type: "text",
            placeholder: "",
            errorMsg: "Vui lòng nhập số điện thoại",
            invalidMsg: "Số điện thoại không hợp lệ",
        },
        address: {
            name: "address",
            label: "Địa chỉ",
            type: "text",
            placeholder: "",
            errorMsg: "Vui lòng nhập địa chỉ",
        },
    },
};

export default form;


